import { render, staticRenderFns } from "./AccountVerification.vue?vue&type=template&id=6c2051b1"
import script from "./AccountVerification.vue?vue&type=script&lang=js"
export * from "./AccountVerification.vue?vue&type=script&lang=js"
import style0 from "./AccountVerification.vue?vue&type=style&index=0&id=6c2051b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports